import { cn } from '@/shared/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentPropsWithRef } from 'react';

export const TableStyle = () => {};

type TableProps = ComponentPropsWithRef<'div'>;
const Table = (props: TableProps) => {
  const { className, children, ...rest } = props;
  return (
    <div className={cn('flex w-full flex-1 shrink-0 flex-col', className)} {...rest}>
      {children}
    </div>
  );
};

const headerCva = cva('flex items-center justify-between h-9 border-y shrink-0', {
  variants: {
    size: {
      sm: 'h-8',
      md: 'h-9',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
type TableHeaderProps = VariantProps<typeof headerCva> & ComponentPropsWithRef<'div'>;
const Header = (props: TableHeaderProps) => {
  const { className, children, size, ...rest } = props;
  return (
    <div className={cn(headerCva({ size }), className)} {...rest}>
      {children}
    </div>
  );
};

const Col = (props: ComponentPropsWithRef<'div'>) => {
  const { className, children, ...rest } = props;
  return (
    <div className={cn('flex shrink-0 px-6 py-3.5 text-xs font-medium', className)} {...rest}>
      {children}
    </div>
  );
};

const Row = (props: ComponentPropsWithRef<'div'>) => {
  const { className, children, ...rest } = props;
  return (
    <div
      className={cn(
        'flex shrink-0 justify-between border-b transition-all duration-200 last:border-b-0 hover:bg-gray-100',
        props.onClick && 'cursor-pointer',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

const tableCellCva = cva('flex items-center text-table-foreground', {
  variants: {
    size: {
      sm: 'text-xs font-medium px-3 py-2.5',
      md: 'text-sm font-medium p-4',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
type TableCellProps = VariantProps<typeof tableCellCva> & ComponentPropsWithRef<'div'>;
const Cell = (props: TableCellProps) => {
  const { className, children, size, ...rest } = props;
  return (
    <div className={cn(tableCellCva({ size }), className)} {...rest}>
      {children}
    </div>
  );
};

TableStyle.Table = Table;
TableStyle.Header = Header;
TableStyle.Col = Col;
TableStyle.Row = Row;
TableStyle.Cell = Cell;
